import { PassengerType } from './contentPassengerType.model';
import { Tooltip } from './contentTooltip.model';

export class ContentBook {
  id: string;
  label: string;
  departLabel: string;
  returnLabel: string;
  advancedSearchLabel: string;
  fromLabel: string;
  travelOrigin: string;
  toLabel: string;
  isShowSearch: string;
  srOnlyText: string;
  searchButton: string;
  travelDestinationLabel: string;
  meetingCode: string;
  meetingCodeFloatingLabel: string;
  edpMeetingCodeDisclaimer: string;
  edpMeetingCodeDisclaimerForFare: string;
  edpMeetingCodeDisclaimerForProgram: string;
  edpMeetingCodeDisclaimerForNoProgram: string;
  moneyLabel: string;
  showprice: string;
  bestFareLabel: string;
  searchByFareClassLabel: string;
  refundableFareLabel: string;
  nearByAirports: string;
  milesLabel: string;
  ecertLabel: string;
  ecertUrl: string;
  eDocforDDCFB: boolean;
  newWindow: string;
  multicityFromLabel: string;
  multicityToLabel: string;
  multicityDepartLabel: string;
  connectionLabel: string;
  connectionFloatingLabel: string;
  addFlightLabel: string;
  removeFlightLabel: string;
  submitUrl: string;
  tripTypes: TripType[] = [];
  passengers: Passanger[] = [];
  passengertype: PassengerType[] = [];
  brands: Brand[] = [];
  fareClasses: FareClass[] = [];
  tooltips: Map<string, Tooltip> = new Map();
  mobileSubmitUrl: string;
  milesPlusMoneyLabel: string;
  flightPlusHotelLabel = '';
  flightPlusCarLabel = '';
  enableFlightPlusCar: boolean;
  maxNumberOfPax: string;
  flightPlusHotelIntercept: string;
  legacyAppUrl: string;
  flightplushotelduration: string;
  milesMobileRedirect: boolean;
  addDisableMetaSearch: boolean;
  altSearchLabel: string;
  hideEditSearchLabel: string;
  searchoptionLabel: string;
  flexibleDates: string;
  toggleMiles: boolean;
  showFares: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['departLabel']) {
        this.departLabel = contentjson['departLabel'];
      }
      if (contentjson['returnLabel']) {
        this.returnLabel = contentjson['returnLabel'];
      }
      if (contentjson['advancedSearchLabel']) {
        this.advancedSearchLabel = contentjson['advancedSearchLabel'];
      }
      if (contentjson['fromLabel']) {
        this.fromLabel = contentjson['fromLabel'];
      }
      if (contentjson['travelOrigin']) {
        this.travelOrigin = contentjson['travelOrigin'];
      }
      if (contentjson['toLabel']) {
        this.toLabel = contentjson['toLabel'];
      }
      if (contentjson['travelDestinationLabel']) {
        this.travelDestinationLabel = contentjson['travelDestinationLabel'];
      }
      if (contentjson['meetingCode']) {
        this.meetingCode = contentjson['meetingCode'];
      }
      if (contentjson['meetingCodeFloatingLabel']) {
        this.meetingCodeFloatingLabel = contentjson['meetingCodeFloatingLabel'];
      }
      if (contentjson['altSearchLabel']) {
        this.altSearchLabel = contentjson['altSearchLabel'];
      } else {
        this.altSearchLabel = '';
      }
      if (contentjson['hideEditSearchLabel']) {
        this.hideEditSearchLabel = contentjson['hideEditSearchLabel'];
      } else {
        this.hideEditSearchLabel = '';
      }
      if (contentjson['edpMeetingCodeDisclaimer']) {
        this.edpMeetingCodeDisclaimer = contentjson['edpMeetingCodeDisclaimer'];
      }
      if (contentjson['edpMeetingCodeDisclaimerForFare']) {
        this.edpMeetingCodeDisclaimerForFare =
          contentjson['edpMeetingCodeDisclaimerForFare'];
      }
      if (contentjson['edpMeetingCodeDisclaimerForProgram']) {
        this.edpMeetingCodeDisclaimerForProgram =
          contentjson['edpMeetingCodeDisclaimerForProgram'];
      }
      if (contentjson['edpMeetingCodeDisclaimerForNoProgram']) {
        this.edpMeetingCodeDisclaimerForNoProgram =
          contentjson['edpMeetingCodeDisclaimerForNoProgram'];
      }
      if (contentjson['moneyLabel']) {
        this.moneyLabel = contentjson['moneyLabel'];
      }
      if (contentjson['showprice']) {
        this.showprice = contentjson['showprice'];
      }
      if (contentjson['bestFareLabel']) {
        this.bestFareLabel = contentjson['bestFareLabel'];
      }
      if (contentjson['searchByFareClassLabel']) {
        this.searchByFareClassLabel = contentjson['searchByFareClassLabel'];
      }
      if (contentjson['refundableFareLabel']) {
        this.refundableFareLabel = contentjson['refundableFareLabel'];
      }
      if (contentjson['nearByAirports']) {
        this.nearByAirports = contentjson['nearByAirports'];
      }
      if (contentjson['milesLabel']) {
        this.milesLabel = contentjson['milesLabel'];
      }
      if (contentjson['milesPlusMoneyLabel']) {
        this.milesPlusMoneyLabel = contentjson['milesPlusMoneyLabel'];
      }
      if (contentjson['ecertLabel']) {
        this.ecertLabel = contentjson['ecertLabel'];
      }
      if (contentjson['ecertUrl']) {
        this.ecertUrl = contentjson['ecertUrl'];
      }
      if (contentjson['eDocforDDCFB']) {
        const edocFlagForDdcfb = contentjson['eDocforDDCFB'];
        this.eDocforDDCFB =
          edocFlagForDdcfb === '' || edocFlagForDdcfb.toLowerCase() === 'false'
            ? false
            : true;
      } else {
        this.eDocforDDCFB = false;
      }
      if (contentjson['newWindow']) {
        this.newWindow = contentjson['newWindow'];
      }
      if (contentjson['multicityFromLabel']) {
        this.multicityFromLabel = contentjson['multicityFromLabel'];
      }
      if (contentjson['multicityToLabel']) {
        this.multicityToLabel = contentjson['multicityToLabel'];
      }
      if (contentjson['multicityDepartLabel']) {
        this.multicityDepartLabel = contentjson['multicityDepartLabel'];
      }
      if (contentjson['connectionLabel']) {
        this.connectionLabel = contentjson['connectionLabel'];
      }
      if (contentjson['connectionFloatingLabel']) {
        this.connectionFloatingLabel = contentjson['connectionFloatingLabel'];
      }
      if (contentjson['addFlightLabel']) {
        this.addFlightLabel = contentjson['addFlightLabel'];
      }
      if (contentjson['srOnlyText']) {
        this.srOnlyText = contentjson['srOnlyText'];
      }
      if (contentjson['isShowSearch']) {
        this.isShowSearch = contentjson['isShowSearch'];
      }
      if (contentjson['searchButton']) {
        this.searchButton = contentjson['searchButton'];
      }
      if (contentjson['removeFlightLabel']) {
        this.removeFlightLabel = contentjson['removeFlightLabel'];
      }
      if (contentjson['submitUrl']) {
        this.submitUrl = contentjson['submitUrl'];
      }
      if (contentjson['tripType']) {
        this.fillTripType(contentjson['tripType']);
      }
      if (contentjson['passengers']) {
        this.fillPassanagers(contentjson['passengers']);
      }
      if (contentjson['brand']) {
        this.fillBrands(contentjson['brand']);
      }
      if (contentjson['fareClass']) {
        this.fillfareClass(contentjson['fareClass']);
      }
      if (contentjson['toolTipDetails']) {
        this.fillTooltipData(contentjson['toolTipDetails']);
      }
      if (
        contentjson['mobileSubmitUrl'] &&
        contentjson['mobileSubmitUrl'].trim() !== ''
      ) {
        this.mobileSubmitUrl = contentjson['mobileSubmitUrl'];
      }
      if (
        contentjson['legacyAppUrl'] &&
        contentjson['legacyAppUrl'].trim() !== ''
      ) {
        this.legacyAppUrl = contentjson['legacyAppUrl'];
      }
      if (contentjson['passengertype']) {
        this.fillPassengerType(contentjson['passengertype']);
      }
      if (contentjson['flightPlusHotelLabel']) {
        this.flightPlusHotelLabel = contentjson['flightPlusHotelLabel'];
      }
      if (contentjson['flightPlusCarLabel']) {
        this.flightPlusCarLabel = contentjson['flightPlusCarLabel'];
      }
      if (contentjson['enableFlightPlusCar']) {
        const aemValueOfFlightPlusCar = contentjson['enableFlightPlusCar'];
        this.enableFlightPlusCar =
          aemValueOfFlightPlusCar === ''
            ? false
            : aemValueOfFlightPlusCar.toLowerCase() === 'false'
            ? false
            : true;
      } else {
        this.enableFlightPlusCar = false;
      }
      if (contentjson['maxNumberOfPax']) {
        this.maxNumberOfPax = contentjson['maxNumberOfPax'];
      }
      if (contentjson['flightPlusHotelIntercept']) {
        this.flightPlusHotelIntercept = contentjson['flightPlusHotelIntercept'];
      }
      if (contentjson['flightplushotelduration']) {
        this.flightplushotelduration = contentjson['flightplushotelduration'];
      }
      if (contentjson['addDisableMetaSearch']) {
        const disableMetaSearch = contentjson['addDisableMetaSearch'];
        this.addDisableMetaSearch =
          disableMetaSearch === '' || disableMetaSearch === undefined
            ? false
            : disableMetaSearch.toLowerCase() === 'false'
            ? false
            : true;
      }
      if (contentjson['milesMobileRedirect']) {
        let aemValue = '';
        aemValue = contentjson['milesMobileRedirect'];
        this.milesMobileRedirect =
          aemValue === '' || aemValue === undefined
            ? false
            : aemValue.toLowerCase() === 'false'
            ? false
            : true;
      } else {
        this.milesMobileRedirect = false;
      }
      if (contentjson['flexibleDates']) {
        this.flexibleDates = contentjson['flexibleDates'];
      }
      if (contentjson['searchoptionLabel']) {
        this.searchoptionLabel = contentjson['searchoptionLabel'];
      }
      if (contentjson['toggleMiles']) {
        this.toggleMiles = contentjson['toggleMiles'] === 'true';
      }
      if (contentjson['showFares']) {
        this.showFares = contentjson['showFares'];
      }
    }
  }

  private fillTripType(tripTypesJsonArray?: any) {
    this.tripTypes = [];
    if (tripTypesJsonArray) {
      for (const tripType of tripTypesJsonArray) {
        this.tripTypes.push(new TripType(tripType));
      }
    }
  }

  private fillPassanagers(passengerJsonArray?: any) {
    this.passengers = [];
    if (passengerJsonArray) {
      for (const passanger of passengerJsonArray) {
        this.passengers.push(new Passanger(passanger));
      }
    }
  }

  private fillBrands(brandsJsonArray?: any) {
    this.brands = [];
    if (brandsJsonArray) {
      for (const brand of brandsJsonArray) {
        this.brands.push(new Brand(brand));
      }
    }
  }

  private fillfareClass(fareClassJsonArray?: any) {
    this.fareClasses = [];
    if (fareClassJsonArray) {
      for (const fareClass of fareClassJsonArray) {
        this.fareClasses.push(new FareClass(fareClass));
      }
    }
  }

  private fillTooltipData(tooltipArray?: any) {
    this.tooltips = new Map();
    if (tooltipArray) {
      for (const tooltip of tooltipArray) {
        this.tooltips.set(tooltip['itemId'], new Tooltip(tooltip));
      }
    }
  }

  private fillPassengerType(passengerTypeArray?: any) {
    this.passengertype = [];
    if (passengerTypeArray) {
      for (const paxType of passengerTypeArray) {
        this.passengertype.push(new PassengerType(paxType));
      }
    }
  }
}

export class TripType {
  tripTypeTitle: any;
  tripTypeValue: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['tripTypeTitle']) {
        this.tripTypeTitle = contentjson['tripTypeTitle'];
      }
      if (contentjson['tripTypeValue']) {
        this.tripTypeValue = contentjson['tripTypeValue'];
      }
    }
  }
}

export class Passanger {
  passengerId: any;
  passengerTitle: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['passengerId']) {
        this.passengerId = contentjson['passengerId'];
      }
      if (contentjson['passengerTitle']) {
        this.passengerTitle = contentjson['passengerTitle'];
      }
    }
  }
}

export class Brand {
  brandId: any;
  brandTitle: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['brandId']) {
        this.brandId = contentjson['brandId'];
      }
      if (contentjson['brandTitle']) {
        this.brandTitle = contentjson['brandTitle'];
      }
    }
  }
}

export class FareClass {
  fareClassId: any;
  fareClassTitle: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['fareClassId']) {
        this.fareClassId = contentjson['fareClassId'];
      }
      if (contentjson['fareClassTitle']) {
        this.fareClassTitle = contentjson['fareClassTitle'];
      }
    }
  }
}
